import OverdueAccountPreviews from "./OverdueAccountsPreview";

const PrintOverdueAccounts: React.FC = () => {
  return (
    <div className="inner-container">
      <OverdueAccountPreviews />
    </div>
  );
};

export default PrintOverdueAccounts;
